import { ColorEnum } from '@/constants/color'
import { FC, useEffect } from 'react'
import { StyleProp, StyleSheet, ViewStyle } from 'react-native'
import Animated, {
    runOnJS,
    useAnimatedStyle,
    useSharedValue,
    withTiming,
} from 'react-native-reanimated'

interface ProgressBarProps {
    duration: number
    onProgressEnd: () => void
    style?: StyleProp<ViewStyle>
}

const ProgressBar: FC<ProgressBarProps> = ({ duration, onProgressEnd, style }) => {
    const progress = useSharedValue(0)

    useEffect(() => {
        progress.value = withTiming(1, { duration }, (isFinished) => {
            if (isFinished) runOnJS(onProgressEnd)()
        })
    }, [progress, duration, onProgressEnd])

    const animatedStyle = useAnimatedStyle(() => ({
        transform: [{ scaleX: progress.value }],
    }))

    return <Animated.View style={[styles.container, animatedStyle, style]} />
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: ColorEnum.BRICK_700,
        height: 3,
        width: '100%',
        transformOrigin: 'left',
    },
})

export default ProgressBar
